/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DiscardUpgradeResponseDTO = {
    processId?: string;
    status?: DiscardUpgradeResponseDTO.status;
    tierType?: DiscardUpgradeResponseDTO.tierType;
};

export namespace DiscardUpgradeResponseDTO {

    export enum status {
        STARTED = 'STARTED',
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
        DISCARDED = 'DISCARDED',
        BLOCKED = 'BLOCKED',
    }

    export enum tierType {
        BRONZE = 'BRONZE',
        SILVER = 'SILVER',
        GOLD = 'GOLD',
        PLATINUM = 'PLATINUM',
    }


}

